import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchReliabilityProfile } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import { constants } from '../../../shared/constants';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from './CustomHighChart';

const colors = _.shuffle(constants.colorObj);
const ChartReliability = ({ type, id, yyyymm }) => {
  const [data, setData] = useState({});
  const [isLoading, setLoading] = useState(true);

  const showData = async (arrData, arrInterruptions, arrDuration) => {
    const chart = await chartObjectCreator({
      chart: {
        renderTo: 'ReliabilityProfileChartContainer',
        type: 'line',
      },
      xAxis: {
        type: 'category',
        categories: arrData,
        title: {
          text: 'Days',
        },
        labels: {
          rotation: 310,
        },
      },
      yAxis: [
        {
          title: {
            text: 'Count',
          },
        },
        {
          title: {
            text: 'Duration (minutes)',
          },
          opposite: true,
        },
      ],
      series: [
        {
          name: 'Interruptions Count',
          type: 'column',
          color: colors[0],
          data: arrInterruptions,
        },
        {
          name: 'Duration',
          type: 'line',
          color: colors[1],
          marker: { symbol: 'circle', radius: 2, enabled: false },
          lineWidth: 3,
          yAxis: 1,
          data: arrDuration,
        },
      ],
    });
    setData(chart);
    setLoading(false);
  };

  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        setLoading(true);
        setData({});
        fetchReliabilityProfile(type, id, yyyymm)
          .then((response) => {
            setLoading(false);
            const { statusCode, result } = response.data;
            if (statusCode !== 200) {
              showData([], [], []);
            } else {
              const arrData = [];
              const arrInterruptions = [];
              const arrDuration = [];
              _.map(result, (res) => {
                const { dt, mon, interruptions, duration } = res;
                arrData.push(`${dt}/${mon}`);
                arrInterruptions.push(interruptions);
                arrDuration.push(duration);
              });
              showData(arrData, arrInterruptions, arrDuration);
            }
          })
          .catch((error) => {
            showData([], [], []);
            console.log(error);
          });
      }
    }
    fetchData();
  }, [type, id, yyyymm]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default React.memo(ChartReliability);
